import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Container, Link } from "@mui/material";

export default function Footer() {
  const { t } = useTranslation(["auth"]);

  return (
    <Box
      sx={{
        height: "60px",
        backgroundColor: (t) => t.palette.grey[900],
      }}
    >
      <Container maxWidth="xl"
                 sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
        <Typography variant="body" sx={{ fontWeight: 700, fontSize: "13px", display: "flex", gap: 2 }}>
          <span>© {new Date().getFullYear()} {t("appName")}</span>
          <Link href={"mailto:iroda@autoexpert.eu"} color="inherit">iroda@autoexpert.eu</Link>
        </Typography>
        <Typography sx={{ fontWeight: 700, fontSize: "13px", display: "flex", gap: 2 }}>
          <Link href={import.meta.env.VITE_TNC_LINK} color="inherit">{t("tnc")}</Link>
          <Link href={import.meta.env.VITE_PP_LINK} color="inherit">{t("pp")}</Link>
        </Typography>
      </Container>
    </Box>
  );
}
